import styled from 'styled-components';

export const Badge = styled.span`
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.sm};
  font-size: ${props => props.theme.typography.sizes.small};
  font-weight: 600;
  background-color: ${props => props.$bgColor || props.theme.colors.backgroundSecondary};
  color: ${props => props.$color || props.theme.colors.text};
`;

export const StatusBadge = styled.span`
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.sm};
  font-size: ${props => props.theme.typography.sizes.small};
  font-weight: 600;
  background-color: ${props => props.isActive ? '#28a74520' : '#dc354520'};
  color: ${props => props.isActive ? '#28a745' : '#dc3545'};
`;
